import type { RouteRecordRaw } from 'vue-router'
import { getComponent } from '../utils'
import PublicLayout from '@/layouts/public-layout.vue'

export const auth_routes: RouteRecordRaw[] = [
  {
    path: '/signup',
    name: 'auth-signup',
    component: () => getComponent(`pages/signup.vue`),
    meta: { title: () => 'Signup', layout: PublicLayout, is_public: true },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => getComponent(`pages/login.vue`),
    meta: { title: () => 'Login', layout: PublicLayout, is_public: true },
  },
  {
    path: '/logout',
    name: 'auth-logout',
    component: () => getComponent(`pages/logout.vue`),
    meta: { title: () => 'Logout', layout: PublicLayout, is_public: true },
  },
]
